
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/next/seminars/3",
      function () {
        return require("private-next-pages/next/seminars/3.tsx");
      }
    ]);
  